import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { FiMenu } from "react-icons/fi";
import { motion, AnimatePresence } from "framer-motion";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";

const Header = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [expanded, setExpanded] = useState(false);
  const user = localStorage.getItem("user");
  const userId = JSON.parse(user);
  const [isOpen, setIsOpen] = React.useState(false);
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  return (
    <div className={"header-inner-main"}>
      <div className={`header-inner`}>
        <img
          src="./logo.png"
          className="logo cursor"
          onClick={() => navigate("/")}
        />
        <div className={`${isMobile ? "dn" : "df"}`}>
          <NavLink className={"nav"} to={"/"}>
            HOME
            <div className="up-arrow"></div>
          </NavLink>
          <NavLink to={"/about-us"} className={"nav"}>
            ABOUT US
            <div className="up-arrow"></div>
          </NavLink>
          <NavLink to={"/products"} className={"nav"}>
            PRODUCTS
            <div className="up-arrow"></div>
          </NavLink>
          <NavLink to={"/certification"} className={"nav"}>
            CERTIFICATIONS
            <div className="up-arrow"></div>
          </NavLink>
          <NavLink to={"/contact-us"} className={"nav"}>
            CONTACT US
            <div className="up-arrow"></div>
          </NavLink>
          {userId == null ? (
            <NavLink className={"nav"} to={"/login"}>
              LOGIN
              <div className="up-arrow"></div>
            </NavLink>
          ) : (
            <NavLink className={"nav"} onClick={toggleDrawer}>
              <FiMenu size={20} cursor={"pointer"} />
            </NavLink>
          )}
        </div>
        <div className={`${isMobile ? "df" : "dn"}`}>
          <FiMenu cursor={"pointer"} onClick={() => setExpanded(!expanded)} />
        </div>
      </div>
      <Drawer
        open={isOpen}
        onClose={toggleDrawer}
        direction="left"
        className=""
      >
        <NavLink
          className={"nav"}
          to={"/dashboard"}
          onClick={() => setIsOpen(false)}
        >
          Dashboard
        </NavLink>
        <NavLink className={"nav"} to={"/temperature"}>
          Temperature
        </NavLink>
        <NavLink className={"nav"} to={"/cones"}>
          Cones
        </NavLink>
        <NavLink className={"nav"} to={"/gas-flow"}>
          Gas Flow
        </NavLink>
      </Drawer>
      <AnimatePresence initial={false}>
        {expanded && (
          <motion.section
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: "auto" },
              collapsed: { opacity: 0, height: 0 },
            }}
            transition={{ duration: 0.8, ease: [0.04, 0.62, 0.23, 0.98] }}
          >
            <NavLink
              className={"link"}
              to={"/"}
              onClick={() => setExpanded(!expanded)}
            >
              HOME
            </NavLink>
            <NavLink
              to={"/about-us"}
              className={"link"}
              onClick={() => setExpanded(!expanded)}
            >
              ABOUT US
            </NavLink>
            <NavLink
              to={"/products"}
              className={"link"}
              onClick={() => setExpanded(!expanded)}
            >
              PRODUCTS
            </NavLink>
            <NavLink
              to={"/certification"}
              className={"link"}
              onClick={() => setExpanded(!expanded)}
            >
              CERTIFICATIONS
            </NavLink>
            <NavLink
              to={"/contact-us"}
              className={"link"}
              onClick={() => setExpanded(!expanded)}
            >
              CONTACT US
            </NavLink>
            <NavLink
              to={"/login"}
              className={"link"}
              onClick={() => setExpanded(!expanded)}
            >
              LOGIN
            </NavLink>
          </motion.section>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Header;
